import React, { useState } from "react";
import PropTypes from "prop-types";
import { createContext, useEffect, useReducer } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import * as Sentry from '@sentry/react';

// third-party

import { Chance } from "chance";

// reducer - state management

import { LOGIN, LOGOUT, SNACKBAR_OPEN } from "../store/actions";
import accountReducer from "../store/accountReducer";

// project imports
import Loader from "../ui-component/Loader";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import {
  clearTokens,
  ensureAccessToken,
  expectedAccountRefusesToken,
  failureEndsSignIn,
  followAccountAcrossTabs,
  forgetLoginAsAccount,
  getRefreshToken,
  loginAsRefusesToken,
  purgeStoredTokens,
  rememberLoginAsAccount,
  sessionServesAccount,
  setAccessToken,
  setRefreshToken as storeRefreshToken,
  stopFollowingAccount,
  tokenUserId,
} from "../utils/tokenStore";
const chance = new Chance();

// constant

const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
};

//
// function isMac() {
//   var platform = window.navigator.platform;
//   var userAgent = window.navigator.userAgent;

//   return platform.toUpperCase().indexOf('MAC') >= 0 ||
//          (platform.toUpperCase().indexOf('IOS') >= 0 && userAgent.indexOf('Mac') != -1);
// }


// K4 Aşama 3 (owner, 2026-10-13): "tokenları localStorage'da tutma". The
// access and refresh tokens live in memory (utils/tokenStore.js); a page
// load starts without them and gets a fresh pair from the browser's Django
// session (tokenStore.ensureAccessToken -> POST /api2/v2/auth/login/ {"session": true}). The
// axios default Authorization header is kept as before.
const setSession = (serviceToken) => {
  if (serviceToken) {
    setAccessToken(serviceToken);
    axios.defaults.headers.common.Authorization = `Bearer ${serviceToken}`;
  } else {
    setAccessToken(null);
    delete axios.defaults.headers.common.Authorization;
  }
};

const setRefreshToken = (refreshToken) => {
  storeRefreshToken(refreshToken || null);
}

// Roles the SPA serves itself; the same list login() checks.
const SPA_ROLES = ["doctor", "ortheroanatec", "ortheroanatecadmin","ortheroanatecsecondadmin","ortheroanatecoutsource","ortheroanateconyx","ortheroadviser"];

// The SPA's entry pages: /new, /new/login and /new/main-panel.
const isSpaLandingPath = () => /(^|\/)new(\/(login|main-panel))?\/?$/.test(window.location.pathname);

// K4 Aşama 3 (owner, 2026-10-13): a staff account (admin, miy, ...) whose
// Django session opens an SPA entry page. Before K4 such a tab had no token
// and showed the sign-in page; with the session as the source of tokens it
// would be signed in, sent to /main-panel, and dashboard-list's
// "localStorage.clear(); reload" for non-doctors would loop for ever, since
// clearing storage no longer signs anyone out. Such a tab shows the sign-in
// page, as before. Staff deep links (operation-upload, contract-upload, ...)
// are not entry pages and keep working with the session's tokens.
const isStaffOnSpaLanding = (user) => !!user && !SPA_ROLES.includes(user.role) && isSpaLandingPath();

// Logs a failed sign-in step without the error object: axios errors carry
// the request headers, Authorization included.
const logAuthFailure = (step, err) => {
  const status = err && err.response ? err.response.status : err && err.status;
  console.warn(`[auth] ${step} failed`, (err && err.code) || "", status || "");
};

// An Error for a sign-in the tab refuses on its own; it carries a short code
// for logAuthFailure, never a token.
const refusedSignIn = (code, message) => Object.assign(new Error(message), { code });

// K4 Aşama 3 (owner, 2026-10-13): the page-start token, refused when this
// tab must not become the account it is for: a "login as" mark for another
// account (tokenStore.loginAsRefusesToken), or an entry link whose
// '?expect=<id>' names another account (tokenStore.expectedAccountRefusesToken).
// The caller's catch then takes the sign-in path.
const tokenForThisTab = async () => {
  const token = await ensureAccessToken();
  if (loginAsRefusesToken(token)) {
    throw refusedSignIn("login_as_changed", "the session is not the login-as account of this tab");
  }
  if (expectedAccountRefusesToken(token)) {
    throw refusedSignIn("account_changed", "the session is not the account the link expects");
  }
  return token;
};

const LOGOUT_URL = "/api2/v2/logout/";

// K4 Aşama 3 (owner, 2026-10-13): POST /api2/v2/logout/, which ends the
// browser's Django session (and blacklists the refresh token when one is
// sent). The session is what signs a page in now, so a logout that never
// reached the server signs nobody out: the next page load would open the
// account again. The usual axios call is tried first; when it fails
// (network, 5xx, maintenance 503) it is sent once more with fetch and
// keepalive, so it survives a navigation. Resolves true when the server
// answered with a 2xx, false otherwise; never rejects.
const endServerSession = async (refresh) => {
  const body = refresh ? { refresh } : {};
  try {
    await axios.post(LOGOUT_URL, body);
    return true;
  } catch (err) {
    logAuthFailure("logout", err);
  }
  try {
    const response = await fetch(LOGOUT_URL, {
      method: "POST",
      credentials: "same-origin",
      keepalive: true,
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    return response.ok;
  } catch (err) {
    logAuthFailure("logout retry", err);
    return false;
  }
};


const checkUserRole = () =>{
  const userData = localStorage.getItem("userData");
  const anatecRoles = ["ortheroanatec", "ortheroanatecadmin","ortheroanatecsecondadmin","ortheroanatecoutsource","ortheroanateconyx"];

  try {
    if(userData && anatecRoles.includes(JSON.parse(userData).role)){
      return  "/orthero-api/v2/accunt/me/"
    }else{
      return "/api2/v2/accunt/me/"
    }
  } catch (error) {
    return "/api2/v2/accunt/me/"
  }

}

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //

const JWTContext = createContext(null);

export const JWTProvider = ({ children }) => {
  const [state, dispatch] = useReducer(accountReducer, initialState);
  const [open, setOpen] = React.useState(false);
  const [brandData, setBrandData] = useState(null);
  const dispatch_redux = useDispatch();
  const intl = useIntl();

  const paths = ['fullversiontwo', 'analysisversiontwo','doctordetail','impressiontwo'];
  const isIframe = window.self !== window.top;
  let pathname = '';
  if (isIframe) {
    try {
      pathname = window.top.location.pathname;
    } catch (e) {
      pathname = window.location.pathname;
    }
  } else {
    pathname = window.location.pathname;
  }  
  
  const isPathNotIncluded = !paths.some(path => pathname.includes(path));

  // K4 Aşama 3 (owner, 2026-10-13): the SPA frame a staff page embeds (the
  // top page's path names one of the paths above). Only a frame counts: the
  // SPA's own top-level routes '/anatec-doctordetail/:doctorPk' and
  // '/adviser-doctordetail/:doctorPk' also contain 'doctordetail', and as a
  // top window they sign in like every other SPA page (me, userData, and
  // following the account across tabs), so their token can never belong to
  // another account than the userData record they show.
  const isEmbeddedStaffFrame = isIframe && !isPathNotIncluded;

  const navigate = useNavigate();

  const azureSasToken = async () => {
    // if (!window.location.href.includes("new/login")) {
    //   try {
    //     const response = await axios.get("/api2/v2/onlySasToken/");
    //     localStorage.setItem("sas", response.data);
    //     localStorage.setItem("sas_update", Date.now().toString());
    //   } catch (err) {
    //     console.log(err);
    //   }
    // }
    return
  };

  const [isMobile, setisMobile] = useState(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));

  const [sasReload, setSasReload] = useState(0);

  const urlNavigator = () => {
    if (
      window.location.href.includes("?next=/en/") ||
      window.location.href.slice(-4).toLowerCase().includes("new")
    ) {
      navigate("/main-panel");
    }
  };

  let sasInit = setTimeout(
    () => localStorage.getItem("userData") && setSasReload(sasReload + 1),
    600000
  );

  useEffect(() => {
    // K4 Aşama 3 (owner, 2026-10-13): a share-link tab (new/viewer2) signs in
    // once per page load. This effect runs again on the 10-minute sasReload
    // timer, and each run in viewer2 rewrote the shared 'userData' record
    // ('{}', then the share account's record). Every other signed-in tab of
    // the browser reads such a write as "another account signed in" and
    // leaves for the sign-in page, so it would lose unsaved work every ten
    // minutes for as long as the share link stays open. The later runs have
    // nothing new to do in viewer2 (same token from the URL, same account).
    if (sasReload > 0 && window.location.href.includes('new/viewer2')) {
      return;
    }
    if (window.location.href.includes('find-doctor') || window.location.href.includes('register-fast') ) {
      localStorage.clear();
    }
    if (!window.location.href.includes('find-doctor') && !window.location.href.includes('register-fast')) {
      if (window.location.href.includes('new/viewer2')) {
        localStorage.setItem("userData", JSON.stringify({}));
      }
      let hiJack = window.localStorage.getItem("hiJack");
      let token_doc = window.localStorage.getItem("token");
      // K4 Aşama 3 (owner, 2026-10-13): the staff "Giriş Yap" / "Portal Giriş
      // Yap" handoff ('hiJack' + 'token', written by the staff pages) is
      // consumed once, before anything else reads it. The staff pages write
      // it only while LEGACY_SPA_SESSION_TOKENS is off (the old build needs
      // it); once it is on, this tab gets the doctor from the session alone
      // and hiJacker below is a fallback for leftovers, to drop later.
      localStorage.removeItem("hiJack");
      localStorage.removeItem("token");

      // K4 Aşama 3 (owner, 2026-10-13): the "login as" tokens go to memory.
      // The staff views behind those buttons (seffaf.views.DoctorLoginPortal,
      // seffaf.views.AdminAccountPortalLogin, distributor.views.DoctorLoginPortal)
      // log this browser in as the doctor (logout() + login()) before they
      // redirect to /new/login, so the reload below comes back as the doctor
      // through the session (POST /api2/v2/auth/login/ {"session": true}). The reload only happens
      // when the session is checked to serve the hiJacked account; otherwise
      // the tab stays on the in-memory tokens (init() below) and is never
      // turned into another account, such as the staff member's.
      const hiJacker = async (hiJack, token_doc) => {
        const response = await axios.post("/api2/v2/auth/login/", {
          hiJack,
          token_doc,
        });
        const { serviceToken, user, refresh } = response.data;

        setSession(serviceToken);
        dispatch({
          type: LOGIN,
          payload: {
            isLoggedIn: true,
            user,
          },
        });
        localStorage.setItem("userData", JSON.stringify(response.data.user));
        setRefreshToken(refresh);
        azureSasToken();

        if (await sessionServesAccount(tokenUserId(serviceToken))) {
          forgetLoginAsAccount();
          window.location.reload();
          return true;
        }
        // The tab stays on this account's in-memory tokens. Its later
        // reloads must not turn it into the session's account (the staff
        // member's): see tokenStore.rememberLoginAsAccount.
        rememberLoginAsAccount(tokenUserId(serviceToken));
        console.warn("[auth] login-as: this browser's session is not the account's; the page stays on its in-memory tokens and is not reloaded");
        return false;
      };

      // K4 Aşama 3 (owner, 2026-10-13): this tab shows the sign-in page and
      // holds no tokens; the storage the tabs share is left alone.
      const signedOutHere = (step, err) => {
        logAuthFailure(step, err);
        stopFollowingAccount();
        forgetLoginAsAccount();
        setSession(null);
        clearTokens();
        navigate("/login");
        dispatch({
          type: LOGOUT,
        });
      };

      // K4 Aşama 3 (owner, 2026-10-13): any failure to get a token ends here,
      // the same sign-in path as before (a failed "login as" handoff too).
      // localStorage.clear() signs every tab of the browser out now (they
      // follow their account across tabs), so it runs only when the server
      // refused this browser's sign-in (tokenStore.failureEndsSignIn: 401
      // no_session / session_ended, the session serving another account,
      // ...). A network blip, a 429, a 5xx or maintenance 503, and the tab's
      // own refusals (staff_landing, login_as_changed, '?expect') end the
      // sign-in in this tab only.
      const signedOut = (step, err) => {
        signedOutHere(step, err);
        if (failureEndsSignIn(err)) {
          window.localStorage.clear();
        }
      };

      const init = async () => {
        if (window.location.href.includes('new/login')) {
          localStorage.removeItem('urlPart');
        }
        // logoutChannel.addEventListener('message', function(event) {
        //   if (event.data.action === 'logout') {
        //     setSession(null);
        //     localStorage.removeItem('userData');
        //     dispatch({
        //       type: LOGOUT,
        //     });
        //     logoutChannel.close();
        //   }
        // });

        if (window.location.href.includes('new/viewer2')) {
          // Share link: the token comes in the URL (a known gap, unchanged by
          // K4 Aşama 3); it is kept in memory only.
          const urlParams = new URLSearchParams(window.location.search);
          const serviceToken = urlParams.get('serviceToken');
          setSession(serviceToken);
          const response2 = await axios.get("/api2/v2/demoaccount/me/");
          localStorage.setItem("userData", JSON.stringify(response2.data.data.user));

          localStorage.setItem("viewerTools", JSON.stringify({
            isViewsWork: false,
            isBg: false,
            isFull: false,
            isShare: false,
            isChat: false,
            isPhotos: false,
            isXrays: false,
            isRx: false,
            isTmt: false,
            isStagging: false,
            isClireq: false,
            isFeatures: false,
            isBolton: false,
            isMove: false,
            isAttach: false,
            isMeasure: false,
            isClipping: false,
            isOcclusal: false,
            isThreed: false,
            isPlan: false,
          }))

          try {
            const meRequestUrl = checkUserRole();
            setSession(await ensureAccessToken());

            const response = await axios.get(meRequestUrl);
            const { user } = response.data;

            dispatch({
              type: LOGIN,
              payload: {
                isLoggedIn: true,
                user,
              },
            });
          } catch (err) {
            // K4 Aşama 3 (owner, 2026-10-13): a share link is not this
            // browser's sign-in; its failure must not sign the other tabs out.
            signedOutHere("viewer2 sign-in", err);
          }

        }
        else {
          if(!isEmbeddedStaffFrame){
          try {
            const meRequestUrl = checkUserRole();
            // K4 Aşama 3 (owner, 2026-10-13): the in-memory token while it is
            // live, else a refresh; a fresh page gets its pair from the
            // browser's Django session. tokenForThisTab refuses a pair for
            // an account this tab must not become.
            setSession(await tokenForThisTab());

            const response = await axios.get(meRequestUrl);
            const { data } = response.data;
            if (isStaffOnSpaLanding(data.user)) {
              throw Object.assign(new Error("staff account on an SPA entry page"), { code: "staff_landing" });
            }
            dispatch_redux({ type: "PENDING_APPROVALS_SET", payload:  data.user?.is_specialist_notifications });
            dispatch_redux({ type: "CONSULTANT_COUNT_SET", payload:  data.user?.tps_consultant_action_required_count });
            localStorage.setItem("softSmileVersion", data.user?.latest_softsmile_version?.version);
            localStorage.setItem("userData", JSON.stringify(data.user));
            // K4 Aşama 3 (owner, 2026-10-13): leave for the sign-in page when
            // another tab signs this account out or signs in as another one.
            followAccountAcrossTabs(data.user && data.user.id);
            let test = data.user

            dispatch({
              type: LOGIN,
              payload: {
                isLoggedIn: true,
                test,
              },
            });
          } catch (err) {
            signedOut("sign-in", err);
          }}else{
            // Staff pages that embed the SPA take the account from userData,
            // as before. K4 Aşama 3 (owner, 2026-10-13): their requests need
            // a token too, which now comes from the session; without one they
            // behave as before (a 401 takes the sign-in path).
            try {
              setSession(await ensureAccessToken());
            } catch (err) {
              logAuthFailure("embedded sign-in", err);
            }

            dispatch({
              type: LOGIN,
              payload: {
                isLoggedIn: true,
                user:JSON.parse(localStorage.getItem("userData")),
              },
            });
          }
        }

        if(isPathNotIncluded){
          azureSasToken();
        }
        urlNavigator();
        // loginChannel.addEventListener('message', function(event) {
        //   if (event.data.action === 'login') {
        //   window.location.reload();
        //   }
        //   loginChannel.close();
        // });
      };

      // if(localStorage.hasOwnProperty('userData')){
      //   if(JSON.parse(localStorage.getItem('userData'))['role'] !== "doctor"){
      //     localStorage.clear();
      //     dispatch({
      //       type: LOGOUT,
      //     });
      //   }
      // }

      // K4 Aşama 3 (owner, 2026-10-13): a "login as" handoff runs first and
      // alone; init() follows only when the page is not reloaded.
      if (hiJack) {
        hiJacker(hiJack, token_doc).then(
          (reloaded) => {
            if (!reloaded) {
              init();
            }
          },
          (err) => signedOut("login-as", err),
        );
      } else {
        init();
      }
    }
  }, [sasReload]);
  // }, [sasReload,logoutChannel,loginChannel]);

  const location = useLocation();

  useEffect(() => {


    const windowUrl =   window.location.origin;
     
    const manuelBrandData = {
      "colors":{
        "main-color": '#f2f4f6'
      },
      "documents":{
        "login_bg": windowUrl.includes("dr.ortohero") ? "https://dr.orthero.com.tr/devstaticnew/devblob/login-back-ground.png" : "https://dr.orthero.com.tr/devstaticnew/devblob/img/1.png"
      },
      "domain": windowUrl,
      "logo": windowUrl.includes("dr.ortohero") ? "https://dr.orthero.com.tr/devstaticnew/devblob/ortohero-original-logo.png" : "https://dr.orthero.com.tr/devstaticnew/pics/orthero-logo.png",
      "name": windowUrl.includes("dr.ortohero") ? "Ortohero " : "Orthero"
    }
    
    const brandData = window.brandData ? window.brandData : manuelBrandData;

    localStorage.setItem('brand', JSON.stringify(brandData));

    const adjustZoom = () => {
      const isFirefox = typeof InstallTrigger !== 'undefined'; // Check for Firefox
      const path = window.location.href;
      const width = window.innerWidth;
      let zoomLevel;

      // find-doctor / doktorbul sayfasında sayfanın genel zoom'u KAPALI kalsın (%100).
      // Sadece harita kendi zoom kontrollerini kullansın. (Sayfa altı boşluk + tık hatası kaynağı)
      if (path.includes('find-doctor') || path.includes('doktorbul')) {
        document.body.style.zoom = '100%';
        document.body.style.transform = '';
        document.body.style.transformOrigin = '';
        document.documentElement.style.removeProperty('height');
        document.documentElement.style.removeProperty('width');
        return;
      }

      if (isMobile && path.includes('new/viewer')) {
        document.body.style.zoom = 100 + "%";
      }
      else if (width < 1920 && width > 1745 && (!path.includes('new/login'))) {
        document.body.style.zoom = 75 + "%"
      }
      else if (width > 1280 && (!path.includes('new/login') && path.includes('new/viewer'))) {
        zoomLevel = 0.8;
      } else if (width <= 1280 && (!path.includes('new/login') && path.includes('new/viewer'))) {
        zoomLevel = 0.64;
      }
      else if (width <= 1745 && width > 1536 && (!path.includes('new/login'))) {
        document.body.style.zoom = 90 + "%"
      }
      else if (width <= 1536 && width > 1280 && (!path.includes('new/login'))) {
        document.body.style.zoom = 77 + "%"
      }
      else if (width <= 1280 && width > 767 && (!path.includes('new/login'))) {
        document.body.style.zoom = 65 + "%"
      }
      else if (isMobile && (!path.includes('new/login'))) {
        document.body.style.zoom = 65 + "%"
      }
      else {
        document.body.style.zoom = 100 + "%"
      }

      if (isFirefox) {
        document.body.style.transform = `scale(${zoomLevel})`;
        document.body.style.transformOrigin = 'top left';
        document.documentElement.style.setProperty('height', `${100 / zoomLevel}vh`);
        document.documentElement.style.setProperty('width', `${100 / zoomLevel}vw`);
        window.scrollTo(0, 0);

      } else {
        document.body.style.zoom = `${zoomLevel * 100}%`;
      }
    };

    adjustZoom();
    window.addEventListener('resize', adjustZoom);
    const urlParts = window.location.href.split("/");
    const urlPart = urlParts[urlParts.length - 1];
    const afterCreatePatient = urlParts.indexOf("create-patient") !== -1;

    if (afterCreatePatient && !isNaN(urlPart)) {
      localStorage.setItem("urlPart", urlPart);
    }
    else {
      if (localStorage.hasOwnProperty("urlPart") && !window.location.href.includes('new/login')) {
        setOpen(true)
      }
    }
    if (sessionStorage.hasOwnProperty('modal')) {
      setTimeout(() => {
        sessionStorage.removeItem('modal');
      }, 2500);
      if (!window.location.href.includes('login')) {
        setOpen(true);
      }
    }


    const userData = localStorage.getItem("userData");
    const sasToken = localStorage.getItem("sas");
    let sasUpdate = localStorage.getItem("sas_update");

    if (sasUpdate) sasUpdate = parseInt(sasUpdate);

    if (!userData) {
      dispatch({
        type: LOGOUT,
      });

      return;
    }

    if (!sasToken || !sasUpdate || Date.now() > sasUpdate + 600000) {
      if(isPathNotIncluded){
        azureSasToken();
      }
    }
  }, [location]);

  const setSentryUser = (userData) => {
    if (window.location.href.includes('dr.orthero') || window.location.href.includes('dr.ortohero')){
      Sentry.setUser({
        id: userData.id,
        email: userData.email,
        username: `${userData.first_name} ${userData.last_name}`,
        country: userData.country,
        role: userData.role,
        is_ort: userData.is_ort
      });
    }
  }
  
  useEffect(() => {
    const stored = localStorage.getItem('userData');
    if(stored){
      console.log("geldim");
      const userData = JSON.parse(stored);
      if (userData) {
        setSentryUser(userData);
      }
    }
    
  }, []);


  const login = async (email, password) => {
    const response = await axios.post("/api2/v2/auth/login/", {
      email,
      password,
    });
    const { serviceToken, user, status, refresh } = response.data;
    // K4 Aşama 3 (owner, 2026-10-13): a credential login replaces any
    // "login as" mark this tab carried.
    forgetLoginAsAccount();
    localStorage.setItem("userData", JSON.stringify(response.data.user));
    
    // K4 Aşama 3 (owner, 2026-10-13): the tokens below go to memory; the
    // reload that follows gets a fresh pair from the Django session that
    // AuthLogin has just opened.
    const allowedRoles = SPA_ROLES;
    if (allowedRoles.includes(response.data.user["role"])) {
      setSession(serviceToken);
      setRefreshToken(refresh); 
      
      // loginChannel.postMessage({ action: 'login' });

      dispatch({
        type: LOGIN,
        payload: {
          isLoggedIn: true,
          user,
        },
      });
      
      localStorage.setItem("userData", JSON.stringify(response.data.user));
      localStorage.setItem("softSmileVersion", response.data.user?.latest_softsmile_version?.version);
      setSentryUser(response.data.user);
      // window.location.replace("tr/new/login");
      
      azureSasToken();
      // Adviser (Danışman Hekim) — doktor/anatec /main-panel akışına girmeden doğrudan kendi paneline
      if (response.data.user["role"] === "ortheroadviser") {
        window.location.replace("/new/main-panel-adviser");
        return;
      }
      window.location.reload();
    } else {
     
      const response = await axios.post("/api2/v2/personelaccess/", {
        email,
        password,
      });
      // console.log("hereee", response.data.user);
      setSession(serviceToken);
      setRefreshToken(refresh); 
      localStorage.setItem("logged_in", true);
      // K4 Aşama 3 (owner, 2026-10-13): the token is no longer copied to
      // localStorage.
      localStorage.getItem("userData");
      window.location.replace("/");
      // window.open('/admindashboard/')
      // window.location.href = "http://localhost:8000/admindashboard/";
      // window.location.replace(`/personelaccess/`);

      azureSasToken();
    }
  };

  const register = async (email, password, firstName, lastName) => {
    // todo: this flow need to be recode as it not verified
    const id = chance.bb_pin();
    const response = await axios.post("/api/account/register", {
      id,
      email,
      password,
      firstName,
      lastName,
    });

    let users = response.data;

    if (
      window.localStorage.getItem("users") !== undefined &&
      window.localStorage.getItem("users") !== null
    ) {
      const localUsers = window.localStorage.getItem("users");
      users = [
        ...JSON.parse(localUsers),
        {
          id,
          email,
          password,
          name: `${firstName} ${lastName}`,
        },
      ];
    }

    window.localStorage.setItem("users", JSON.stringify(users));
  };

  const logout = async () => {
    // K4 Aşama 3 (owner, 2026-10-13): always called. The Django session is
    // what signs a page in now, so it has to end even when this page holds
    // no refresh token (the server blacklists the refresh token when one is
    // sent, and ends the session either way). When the server cannot be
    // reached, the browser is still signed in: clearing this page and
    // showing the sign-in page would only hide that (the next load signs the
    // account in again, e.g. for the next person at a shared clinic PC). So
    // the page stays as it is and says the logout failed; the user can retry.
    const ended = await endServerSession(getRefreshToken());
    if (!ended) {
      console.warn("[auth] logout did not reach the server; this browser is still signed in");
      dispatch_redux({
        type: SNACKBAR_OPEN,
        open: true,
        message: intl.formatMessage({ id: "feedback.alert.error", defaultMessage: "An error occurred, please try again." }),
        variant: "alert",
        alertSeverity: "error",
        anchorOrigin: { vertical: "top", horizontal: "center" },
        transition: "SlideDown",
      });
      return;
    }
    if (window.location.href.includes('dr.orthero') || window.location.href.includes('dr.ortohero')){
      Sentry.setUser(null);
    }
    stopFollowingAccount();
    forgetLoginAsAccount();
    clearTimeout(sasInit);
    setSession(null);
    setRefreshToken(null);
    clearTokens();
    dispatch({ type: LOGOUT });
    localStorage.removeItem("userData");
    localStorage.removeItem('urlPart');
    // Leftovers of builds that kept the tokens in localStorage.
    purgeStoredTokens();
    window.location.href = "/new/login";
  };

  // let modals = {
  //   'urlPart':<CaseCreateReminder setOpen = {setOpen} />,
  //   'langChange': <Detect setOpen = {setOpen} />
  //  }

  // const modalOpenHandler = modal => modals[modal];

  const resetPassword = (email) => console.log(email);

  const updateProfile = () => { };

  if (state.isInitialized !== undefined && !state.isInitialized) {
    return <Loader />;
  }

  return (
    <JWTContext.Provider
      value={{
        ...state,
        login,
        logout,
        register,
        resetPassword,
        updateProfile,
      }}
    >
      {children}
    </JWTContext.Provider>
  );
};

JWTProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default JWTContext;
